import { ListLayout } from '@ingrid/luterkort-react';

import { useTranslatedFormLabel } from '../hooks';
import { Schema } from '../queries';

interface Props {
  schema: Schema;
  path?: string;
}

export function SchemaDisplayInteger({ schema, path = '' }: Props) {
  const label = useTranslatedFormLabel({ path });

  if (schema.type !== 'integer') {
    return null;
  }

  /**
   * Figure out if the value should be a plain integer, or an actual option value (oneOf)
   */
  const value = schema.oneOf?.find(o => o.const === schema.value)?.title ?? schema.value;

  return (
    <ListLayout.Stack>
      <ListLayout.SecondaryText>{label}</ListLayout.SecondaryText>
      <ListLayout.PrimaryText>{value ?? '-'}</ListLayout.PrimaryText>
    </ListLayout.Stack>
  );
}
